/* Page de vente : apparition, compteurs, calculateur, barre collante, UTM, événements.
   Vanilla, sans dépendance. Chargé une fois via le layout. */
(function () {
  'use strict';
  if (window.OP) return;
  window.OP = { version: '1.0.0' };

  var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fmtEntier = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 });
  var fmtDec = new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function euros(n, dec) { return (dec ? fmtDec : fmtEntier).format(n) + ' €'; }

  /* ---------- 1. Apparition ---------- */
  function initReveal() {
    var cibles = $$('.op-reveal');
    if (!cibles.length) return;
    if (reduit || !('IntersectionObserver' in window)) {
      cibles.forEach(function (el) { el.classList.add('est-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('est-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    cibles.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 2. Compteurs ---------- */
  function animerCompteur(el) {
    var cible = parseFloat(el.getAttribute('data-op-cible'));
    var suffixe = el.getAttribute('data-op-suffixe') || '';
    var fige = el.hasAttribute('data-op-fige');
    if (isNaN(cible)) { el.textContent = el.getAttribute('data-op-vide') || '…'; el.classList.add('est-vide'); return; }
    if (fige || reduit) { el.textContent = fmtEntier.format(cible) + suffixe; return; }
    var debut = null, duree = 1400;
    function pas(t) {
      if (!debut) debut = t;
      var p = Math.min(1, (t - debut) / duree);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = fmtEntier.format(Math.round(cible * e)) + suffixe;
      if (p < 1) requestAnimationFrame(pas);
    }
    requestAnimationFrame(pas);
  }
  function initCompteurs() {
    var els = $$('[data-op-cible]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(animerCompteur); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { animerCompteur(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.3 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 3. Calculateur ---------- */
  function initCalculateur() {
    var racine = $('[data-op-calc]');
    if (!racine) return;
    var cfg = {
      outils: parseFloat(racine.getAttribute('data-outils')) || 150,
      vuesParc: parseFloat(racine.getAttribute('data-vues-parc')) || 0
    };
    var budget = $('[data-op-budget]', racine);
    var budgetR = $('[data-op-budget-range]', racine);
    var cpm = $('[data-op-cpm]', racine);
    var cpmR = $('[data-op-cpm-range]', racine);
    var out = {
      vues: $('[data-op-out="vues"]', racine),
      cpmAuj: $('[data-op-out="cpm-auj"]', racine),
      cpmIci: $('[data-op-out="cpm-ici"]', racine),
      reste: $('[data-op-out="reste"]', racine),
      outils: $('[data-op-out="outils"]', racine),
      mois: $('[data-op-out="mois"]', racine),
      an: $('[data-op-out="an"]', racine),
      blocReste: $('[data-op-bloc="reste"]', racine),
      blocAlerte: $('[data-op-bloc="alerte"]', racine),
      blocLigne: $('[data-op-bloc="ligne"]', racine)
    };
    var herosCpm = $$('[data-op-hero-cpm]');

    function borne(v, min, max) { return Math.min(max, Math.max(min, v)); }
    function lire(input) {
      var v = parseFloat(String(input.value).replace(',', '.'));
      return isNaN(v) ? parseFloat(input.getAttribute('min')) : v;
    }
    function calculer() {
      var b = borne(lire(budget), parseFloat(budget.min), parseFloat(budget.max));
      var c = borne(lire(cpm), parseFloat(cpm.min), parseFloat(cpm.max));
      var vues = (b / c) * 1000;
      var reste = Math.max(0, b - cfg.outils);
      var pasRentable = b < cfg.outils;

      if (out.vues) out.vues.textContent = fmtEntier.format(Math.round(vues));
      if (out.cpmAuj) out.cpmAuj.textContent = euros(c, true);
      if (out.cpmIci) {
        out.cpmIci.textContent = cfg.vuesParc > 0 ? euros((cfg.outils / cfg.vuesParc) * 1000, true) : 'relevé en attente';
      }
      if (out.reste) out.reste.textContent = euros(reste);
      if (out.outils) out.outils.textContent = euros(cfg.outils);
      if (out.mois) out.mois.textContent = euros(reste) + ' / mois';
      if (out.an) out.an.textContent = euros(reste * 12) + ' / an';
      if (out.blocAlerte) out.blocAlerte.hidden = !pasRentable;
      if (out.blocLigne) out.blocLigne.hidden = pasRentable;
      herosCpm.forEach(function (el) { el.textContent = fmtEntier.format(c); });
    }
    function lier(champ, range) {
      if (!champ) return;
      champ.addEventListener('input', function () { if (range) range.value = champ.value; calculer(); });
      champ.addEventListener('blur', function () { champ.value = borne(lire(champ), parseFloat(champ.min), parseFloat(champ.max)); if (range) range.value = champ.value; calculer(); });
      if (range) range.addEventListener('input', function () { champ.value = range.value; calculer(); });
    }
    lier(budget, budgetR);
    lier(cpm, cpmR);
    calculer();
  }

  /* ---------- 4. Barre collante ---------- */
  function initBarre() {
    var barre = $('[data-op-colle]');
    var hero = $('[data-op-hero]');
    if (!barre) return;
    if (!hero || !('IntersectionObserver' in window)) { barre.classList.add('est-visible'); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { barre.classList.toggle('est-visible', !e.isIntersecting); });
    }, { threshold: 0 });
    io.observe(hero);
    var fin = $('[data-op-fin]');
    if (fin) {
      var io2 = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) barre.classList.remove('est-visible'); else if (!heroVisible()) barre.classList.add('est-visible'); });
      }, { threshold: 0.2 });
      io2.observe(fin);
    }
    function heroVisible() { var r = hero.getBoundingClientRect(); return r.bottom > 0 && r.top < window.innerHeight; }
  }

  /* ---------- 5. UTM conservés jusqu'à la commande ---------- */
  function initUtm() {
    var cles = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
    var params = new URLSearchParams(window.location.search);
    var stock = {};
    try { stock = JSON.parse(sessionStorage.getItem('op_utm') || '{}'); } catch (e) { stock = {}; }
    var trouve = false;
    cles.forEach(function (k) { var v = params.get(k); if (v) { stock[k] = v.slice(0, 120); trouve = true; } });
    if (trouve) { try { sessionStorage.setItem('op_utm', JSON.stringify(stock)); } catch (e) {} }
    $$('[data-op-utm]').forEach(function (input) { input.value = stock[input.getAttribute('data-op-utm')] || ''; });
  }

  /* ---------- 6. Événements (GA4 / pixel via les apps) ---------- */
  function produit() {
    var s = $('#op-produit-json');
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }
  function pousser(nom, data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: nom }, data));
    if (typeof window.gtag === 'function') window.gtag('event', nom, data);
    document.dispatchEvent(new CustomEvent('op:' + nom, { detail: data }));
  }
  function initEvenements() {
    var p = produit();
    if (!p) return;
    var item = { item_id: String(p.id), item_name: p.title, price: p.price, currency: p.currency, quantity: 1 };
    pousser('view_content', { currency: p.currency, value: p.price, items: [item] });
    $$('[data-op-buy]').forEach(function (form) {
      form.addEventListener('submit', function () {
        pousser('add_to_cart', { currency: p.currency, value: p.price, items: [item] });
      });
    });
  }

  /* ---------- 7. Checklist Jour 0 (état local au navigateur) ---------- */
  function initChecklist() {
    var liste = $('[data-op-checklist]');
    if (!liste) return;
    var cle = 'op_j0_' + (liste.getAttribute('data-op-cle') || 'defaut');
    var barre = $('[data-op-progres] i');
    var cases = $$('input[type="checkbox"]', liste);
    var etat = {};
    try { etat = JSON.parse(localStorage.getItem(cle) || '{}'); } catch (e) {}
    function maj() {
      var faits = cases.filter(function (c) { return c.checked; }).length;
      if (barre) barre.style.width = Math.round((faits / cases.length) * 100) + '%';
      var compteur = $('[data-op-progres-texte]');
      if (compteur) compteur.textContent = faits + ' / ' + cases.length;
    }
    cases.forEach(function (c, i) {
      c.checked = !!etat[i];
      c.addEventListener('change', function () { etat[i] = c.checked; try { localStorage.setItem(cle, JSON.stringify(etat)); } catch (e) {} maj(); });
    });
    maj();
  }

  /* ---------- 8. Vidéos : lecture au scroll ---------- */
  function initVideos() {
    var vids = $$('video[data-op-scroll]');
    if (!vids.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { v.play().catch(function () {}); } else { v.pause(); }
      });
    }, { threshold: 0.35 });
    vids.forEach(function (v) { io.observe(v); });
  }

  function demarrer() {
    initReveal(); initCompteurs(); initCalculateur(); initBarre(); initUtm(); initEvenements(); initChecklist(); initVideos();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer); else demarrer();
  document.addEventListener('shopify:section:load', demarrer);
})();
